import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProjectContext = createContext(null);

export const ProjectProvider = ({ children }) => {
  const { user } = useAuth();
  const [projects, setProjects] = useState(null);
  const [projectId, setProjectId] = useState(localStorage.getItem("rg_project") || "");

  const reload = async () => {
    const { data } = await api.get("/projects");
    setProjects(data);
    setProjectId((current) => {
      const valid = data.find((p) => p.id === current);
      const next = valid ? current : data[0]?.id || "";
      if (next) localStorage.setItem("rg_project", next);
      return next;
    });
    return data;
  };

  useEffect(() => {
    if (!user) return;
    reload().catch(() => setProjects([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const selectProject = (id) => {
    localStorage.setItem("rg_project", id);
    setProjectId(id);
  };

  const project = projects?.find((p) => p.id === projectId) || null;

  return (
    <ProjectContext.Provider value={{ projects, project, projectId, selectProject, reload }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);
